import {useFormik} from 'formik';
import {useState} from 'react';
import {UpdateProjectDocumentDTO, ProjectDocumentModel, useProjectDocumentById} from '../../../entities';
import * as Yup from 'yup';
import {AxiosError} from 'axios';

type UseEditProjectDocumentFormProps = {
  documentId: string;
  document: ProjectDocumentModel | null;
  setOpen: (open: boolean) => void;
};

export const useEditProjectDocumentForm = ({documentId, document, setOpen}: UseEditProjectDocumentFormProps) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const {updateProjectDocumentMutation} = useProjectDocumentById(documentId);

  const onSubmit = async (values: UpdateProjectDocumentDTO) => {
    setErrorMessage(null);
    try {
      const formattedValues: UpdateProjectDocumentDTO = {
        title: values.title,
        priority: values.priority,
      };

      await updateProjectDocumentMutation.mutateAsync(formattedValues);
      setOpen(false);
    } catch (error: any) {
      setErrorMessage(error?.response?.data?.detail || 'Произошла ошибка при обновлении документа');
    }
  };

  const formik = useFormik({
    initialValues: {
      title: document?.title || '',
      priority: document?.priority || 1,
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      title: Yup.string().max(256, 'Название не должно превышать 256 символов').required('Название обязательно'),
      priority: Yup.number().min(1, 'Приоритет должен быть минимум 1').required('Приоритет обязателен'),
    }),
    onSubmit,
  });

  return {
    ...formik,
    isLoading: updateProjectDocumentMutation.isPending,
    submitError: updateProjectDocumentMutation.error
      ? (updateProjectDocumentMutation.error as AxiosError<ApiError>).response?.data
      : undefined,
    errorMessage,
    submitForm: () => formik.handleSubmit(),
  };
};

